// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion--accordion--2BQIW","arrowButton":"Accordion--arrow-button--3G4MA"};